import { Routes } from '@angular/router';

import { ProgramComponent } from './pages';

export const programRoutes: Routes = [
    {
        path: ':clientCode/program',
        component: ProgramComponent,
        pathMatch: 'full'
    }
];
